//import StatementIndex, { sloader } from './index';
//import CryptoDeposit from './Crypto';
import ReceiptPage,{sloader} from './index';
import { Outlet, Link, useLoaderData, Form } from 'react-router-dom';


import af from './style.module.scss';

function Receipt() {
  //
  return (
    <div className={af.body}>
      <div >
        <Outlet />
      </div>
    </div>
  );
}
//    { index: true, element: <AddFundsIndex /> },

export const receiptroutes = {
  path: `receipt`,
  //loader: mostrloader(apiContext),
  element: <Receipt />,
  children: [
    { index: true, element: <ReceiptPage />, loader: sloader },
    {
      path: ':trans',
      element: <ReceiptPage />, loader: sloader 
      //loader: contactLoader,
    }
  ],
};
